import Vue from 'vue'
import LogRocket from 'logrocket'
import UserAccess from '../../userAccessLevel'

const state = {
  adminData: {},
  adminEventID: null,
  adminFor: [],
  userListToken: null,
  logRocketEnabled: false,
  showAccessList: []
}

const mutations = {
  setLogRocketEnabled: (state, payload) => {
    state.logRocketEnabled = true
  },
  setAdminData: (state, payload) => {
    state.adminData = payload
  },
  setUserListToken: (state, payload) => {
    state.userListToken = payload.token
  },
  setAdminFor: (state, payload) => {
    state.adminFor = payload
  },
  setAdminEntryData: (state, payload) => {
    Vue.set(state.adminData, 'entries', payload)
  },
  setAdminEntryReportData: (state, payload) => {
    Vue.set(state.adminData, 'entriesReport', payload)
  },
  updateAdminEvent: (state, payload) => {
    Object.keys(payload).forEach(key => {
      Vue.set(state.adminData.event, key, payload[key])
    })
  },
  updaateAdminEventStatus: (state, payload) => {
    Vue.set(state.adminData.event, 'status', payload.status)
  },
  setExhibitorNumber: (state, payload) => {
    let exhibitor = state.adminData.exhibitors.filter(e => { return e.exhibitor_id === payload.exhibitor_id })[0]
    Vue.set(exhibitor, 'exhibitor_number', payload.exhibitor_number)
  },
  setEntryNumber: (state, payload) => {
    let entry = state.adminData.entries.filter(eg => { return eg.entry_id === payload.entry_id })[0]
    Vue.set(entry, 'entry_number', payload.entry_number)
  },
  addEntry_admin: (state, newEntry) => {
    state.adminData.entry_groups.forEach(eg => {
      if (eg.entry_group_id === newEntry.entry_group_id) {
        Vue.set(eg.entries, eg.entries.length, newEntry)
      }
    })
  },
  updateEntry_admin: (state, payload) => {
    // {index: index, type: payload.entryType.toLowerCase(), entry: updatedEntry})
    let entryGroup = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0]
    Vue.set(entryGroup.entries, payload.index, payload.entry)
  },
  deleteEntry_admin: (state, payload) => {
    let entryGroup = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0]
    Vue.delete(entryGroup.entries, payload.index)
  },
  addShowToEntry_admin: (state, payload) => {
    let entryGroup = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0]
    entryGroup.entries[payload.index].shows.push(payload.show)
  },
  removeShowFromEntry_admin: (state, payload) => {
    let entryGroup = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0]
    Vue.delete(entryGroup.entries[payload.index].shows, entryGroup.entries[payload.index].shows.findIndex((s) => s.show_id === payload.showID || s.value === payload.showID))
  },
  setEntryGroup_admin: (state, payload) => {
    let entryGroupID = payload.entry_group.entry_group_id
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === entryGroupID)
    Vue.set(state.adminData.entry_groups, index, payload.entry_group)
  },
  setAnimals_admin: (state, payload) => {
    Vue.set(state.adminData, 'current_animals', payload.animals)
  },
  setInvoiceData_admin: (state, payload) => {
    let entryGroupID = payload.entry_group_id
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === entryGroupID)
    Vue.set(state.adminData.entry_groups[index], 'invoice', payload.invoice_data)
  },
  setInvoiceLoading: (state, payload) => {
    let entryGroupID = payload.entry_group_id
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === entryGroupID)
    Vue.set(state.adminData.entry_groups[index], 'loading_balance', true)
  },
  // Edit Event Mutators
  adminDataAddShow: (state, payload) => {
    state.adminData.event.shows.push(payload)
  },
  adminDataAddPricing: (state, payload) => {
    state.adminData.pricing.push(payload)
  },
  setAdminDataPayments: (state, payload) => {
    Vue.set(state.adminData, 'payments', payload)
  },
  adminDataAddPayment: (state, payload) => {
    state.adminData.payments.push(payload)
  },
  adminDataSetNewShowID: (state, payload) => {
    state.adminData.event.shows[state.adminData.event.shows.length - 1].show_id = payload.show_id
  },
  adminDataRemoveNewShow: (state) => {
    state.adminData.event.shows.pop()
  },
  adminDataSetNewPaymentID: (state, payload) => {
    state.adminData.payments[state.adminData.payments.length - 1].payment_id = payload.payment_id
  },
  adminDataRemoveNewPayment: (state) => {
    state.adminData.payments.pop()
  },
  adminDataRemovePayment: (state, payload) => {
    state.adminData.payments = state.adminData.payments.filter(p => {
      return p.payment_id !== payload.payment_id
    })
  },
  adminDataRemovePricing: (state, payload) => {
    state.adminData.pricing = state.adminData.pricing.filter(p => {
      return p.event_pricing_id !== payload.event_pricing_id
    })
  },
  adminDataSetNewPricingID: (state, payload) => {
    state.adminData.pricing[state.adminData.pricing.length - 1].event_pricing_id = payload.event_pricing_id
  },
  adminDataRemoveShow: (state, payload) => {
    state.adminData.event.shows = state.adminData.event.shows.filter(s => {
      return s.show_id !== payload.show_id
    })
  },
  adminDataUpdateShow: (state, payload) => {
    state.adminData.event.shows.forEach(s => {
      if (s.show_id === payload.show_id) {
        s = payload
      }
    })
  },
  adminDataUpdatePricing: (state, payload) => {
    state.adminData.pricing.forEach(p => {
      if (p.event_pricing_id === payload.event_pricing_id) {
        p = payload
      }
    })
  },
  adminDataCoverPhotoURL: (state, payload) => {
    state.adminData.event.coverPhotoURL = payload.url
  },
  adminDataUpdateFile: (state, payload) => {
    // TODO: Make file an object with name keys to URL
    // state.adminData.event.files[payload.name] = payload.url
    state.adminData.event.files = [payload]
  },
  setEventPricing: (state, payload) => {
    state.pricing = payload
  },
  setCheckInComplete: (state, payload) => {
    // let entryGroupID = payload.entry_group_id
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === payload.entry_group_id)
    Vue.set(state.adminData.entry_groups[index], 'checkin_complete', payload.complete)
    // state.adminData.entry_groups[index].checkin_complete = payload.complete
  },
  setMemberStatus: (state, payload) => {
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === payload.entry_group_id)
    state.adminData.entry_groups[index].member_pricing = payload.member_pricing
  },
  setDateEntered: (state, payload) => {
    let index = state.adminData.entry_groups.findIndex(eg => eg.entry_group_id === payload.entry_group_id)
    state.adminData.entry_groups[index].date_entered = payload.date_entered
  },
  // Sponsors
  addSponsor: (state, payload) => {
    state.adminData.event.sponsors.push(payload)
  },
  removeSponsor: (state, payload) => {
    Vue.delete(state.adminData.event.sponsors, payload.index)
  },
  // For Addiong Show Dynamic
  addEventShowType: (state, payload) => {
    state.adminData.event_show_types.push(payload)
  },
  addClassConfig: (state, payload) => {
    state.adminData.class_configurations.push(payload)
  },
  // Exhibitors
  // Commented out on 4/28
  addToExhibitorList_admin: (state, exhibitor) => {
    state.adminData.exhibitors.push(exhibitor)
  },
  updateExhibitorInList_admin: (state, exhibitor) => {
    state.adminData.exhibitors.forEach(e => {
      if (e.exhibitor_id === exhibitor.exhibitor_id) {
        Vue.set(e, 'entry_details', exhibitor.exhibitor_details)
      }
    })
  },
  /* New Generic Mutators  */
  adminDataAddData: (state, payload) => {
    state.adminData[payload.name].push(payload)
  },
  adminDataSetNewDataID: (state, payload) => {
    state.adminData[payload.name][state.adminData[payload.name].length - 1][payload.idName] = payload.id
  },
  adminDataUpdateData: (state, payload) => {
    state.adminData[payload.name].forEach((d, i) => {
      if (d[payload.idName] === payload[payload.idName]) {
        Vue.set(state.adminData[payload.name], i, payload)
      }
    })
  },
  // Files
  adminDataUpdateFiles: (state, files) => {
    state.adminData.event.files = files
  },
  // Entry Questions
  adminDataAddEntryQuestion: (state, entryQuestion) => {
    state.adminData.event.entry_questions.push(entryQuestion)
  },
  adminDataUpdateEntryQuestion: (state, entryQuestion) => {
    state.adminData.event.entry_questions.forEach(eq => {
      if (eq.entry_question_id === entryQuestion.entry_question_id) {
        eq = entryQuestion
      }
    })
  },
  adminDataRemoveEntryQuestion: (state, entryQuestion) => {
    state.adminData.event.entry_questions = state.adminData.event.entry_questions.filter(eq => {
      return eq.entry_question_id !== entryQuestion.entry_question_id
    })
  },
  // Users Access
  addAdminUserAccess: (state, userAccess) => {
    state.adminData.event_user_access.push(userAccess)
  },
  removeAdminUserAccess: (state, toDelete) => {
    state.adminData.event_user_access = state.adminData.event_user_access.filter(item => item.id !== toDelete.id)
  },
  setEntryQuestionReservations_admin: (state, payload) => {
    let eq = state.adminData.event.entry_questions.filter(eq => eq.entry_question_id === payload.entry_question_id)[0]
    Vue.set(eq.details, 'number_reserved', payload.reserved)
  },
  setEventEntryQuestions_admin: (state, payload) => {
    // state.currentEvent.entry_questions = payload
    Vue.set(state.adminData.event, 'entry_questions', payload)
  },
  updateEventSettings_admin: (state, payload) => {
    Vue.set(state.adminData.event.event_settings, payload.field, payload.value)
  },
  updateShowAccessList: (state, payload) => {
    state.adminData.event_user_access.forEach(ua => {
      if (ua.user_id === payload.user_id) {
        if (ua.all_show_access) {
          let list = []
          state.adminData.event.shows.forEach(s => {
            list.push(s.show_id)
          })
          Vue.set(state, 'showAccessList', list )
        } else {
          Vue.set(state, 'showAccessList', ua.show_access_list )
        }
      }
    })
  }
}

const actions = {
  loadAdminData: ({commit, state, rootState, dispatch, getters}, payload) => {
    return rootState.apiInstance.get(`/callFunction/adminData?userID=${getters.getUserID}`)
      .then(response => {
        commit('setAdminFor', response.data.data.adminFor)
        commit('appInitiated')
      })
  },
  loadAdminEventData: ({commit, state, rootState, dispatch, getters}, payload) => {
    if (process.env.NODE_ENV !== 'development') {
      if (!state.logRocketEnabled) {
        LogRocket.init('kzaivo/showman')
        commit('setLogRocketEnabled')
        LogRocket.identify(rootState.user.user_id, {
          email: rootState.user.email,
          name: `${rootState.user.first_name} ${rootState.user.last_name}`
        })
      }
    }
    return rootState.apiInstance.get(`/getAdminData?event_id=${payload.event_slug}${payload.year ? `&year=${payload.year}` : ''}`)
      .then(response => {
        commit('setAdminData', response.data.data)
        dispatch('getUserListToken', {})
        commit('updateShowAccessList', {user_id: getters.getUserID})
      })
  },
  getUserListToken: ({commit, state, rootState, getters}, payload) => {
    return rootState.apiInstance.get(`/userlist/getUserListToken?id=${getters.adminEventID}`)
      .then(response => {
        commit('setUserListToken', {token: response.data.token})
      })
  },
  loadAdminEntryData: ({commit, state, rootState, dispatch, getters}, payload) => {
    return rootState.apiInstance.get(`/callFunction/allEntiresReporting?event_id=${payload.event_id}`)
      .then(response => {
        commit('setAdminEntryData', response.data.data.entries)
      })
  },
  loadAdminEntryReportData: ({commit, state, rootState, dispatch, getters}, payload) => {
    return rootState.apiInstance.get(`/callFunction/allEntiresReportingNew?event_id=${payload.event_id}`)
      .then(response => {
        commit('setAdminEntryReportData', response.data.data.entries)
      })
  },
  // Admin Event Actions
  createNewShow: ({commit, state, getters, rootState}, newShow) => {
    if (newShow.judge) {
      newShow.judge_id = newShow.judge.judge_id
    } else {
      newShow.judge = {}
      newShow.judge_id = null
    }
    newShow.event_id = getters.adminEventID
    newShow.admin_id = state.adminData.event.admin_id
    newShow.created_by = getters.getUserID

    commit('adminDataAddShow', newShow)

    return rootState.apiInstance.post(`/data/shows/`, newShow)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataSetNewShowID', {show_id: response.data.data.show_id})
        } else {
          commit('adminDataRemoveNewShow')
        }
      })
  },
  removeShow: ({commit, rootState}, payload) => {
    return rootState.apiInstance.delete(`/data/shows/${payload.show_id}`)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataRemoveShow', payload)
        } else {
          return Promise.reject(new Error('Show Not Deleted'))
        }
      })
  },
  updateEvent: ({commit, rootState}, payload) => {
    return rootState.apiInstance.put(`/data/events/${payload.event_id}`, payload)
      .then(response => {
        if (response.status === 200) {
          commit('updateAdminEvent', payload)
        }
      })
  },
  updateEventStatus ({commit, rootState}, payload) {
    return rootState.apiInstance.put(`/data/events/${payload.event_id}`, payload)
      .then(response => {
        if (response.status === 200) {
          commit('updaateAdminEventStatus', payload)
        }
      })
  },
  updateShow: ({commit, rootState}, payload) => {
    payload.judge_id = payload.judge ? payload.judge.judge_id : null
    return rootState.apiInstance.put(`/data/shows/${payload.show_id}`, payload)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataUpdateShow', payload)
        }
      })
  },
  createNewPricing: ({commit, state, getters, rootState}, pricingRule) => {
    pricingRule.admin_id = state.adminData.event.admin_id
    pricingRule.created_by = getters.getUserID
    pricingRule.event_id = getters.adminEventID

    commit('adminDataAddPricing', pricingRule)

    return rootState.apiInstance.post('/data/eventPricing', pricingRule)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataSetNewPricingID', {event_pricing_id: response.data.data.event_pricing_id})
        } else {
          commit('adminDataRemovePricing')
          return Promise.reject(new Error('Pricing rule not added.'))
        }
      })
      .catch(error => {
        commit('adminDataRemovePricing')
        return Promise.reject(error)
      })
  },
  updatePricing: ({commit, rootState}, pricingRule) => {
    return rootState.apiInstance.put(`/data/eventPricing/${pricingRule.event_pricing_id}`, pricingRule)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataUpdatePricing', pricingRule)
        } else {
          return Promise.reject(new Error('Pricing rule not updated.'))
        }
      })
  },
  removePricing: ({commit, rootState}, pricingRule) => {
    return rootState.apiInstance.delete(`/data/eventPricing/${pricingRule.event_pricing_id}`)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataRemovePricing', pricingRule)
        } else {
          return Promise.reject(new Error('Rule not deleted'))
        }
      })
  },
  uploadEventCoverPhoto: ({dispatch, commit, state, rootState, getters}, payload) => {
    return rootState.apiInstance.post('/image-upload', payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        if (response.status === 200) {
          commit('adminDataSetCoverPhotoURL', {url: response.data.imageUrl})
          dispatch('updateEvent', {eventID: getters.adminEventID, coverPhotoURL: response.data.imageUrl})
        }
      })
  },
  uploadEventFile: ({commit, dispatch, state, rootState, getters}, payload) => {
    return rootState.apiInstance.post('/image-upload', payload.file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(response => {
        if (response.status === 200) {
          var file = {
            name: payload.name,
            url: response.data.imageUrl
          }
          // TODO: Update how files are stored
          commit('adminDataUpdateFile', file)
          dispatch('updateEvent', {eventID: getters.adminEventID, files: JSON.stringify(state.adminData.event.files)})
        }
      })
  },

  //Load Admin Payments
  loadInAdminPayments: ({commit}, payments) => {
    commit('setAdminDataPayments', payments)
  },
  // Credits/Payments
  addEntryCredit: ({commit, dispatch, state, getters, rootState}, entryCredit) => {
    entryCredit.admin_id = state.adminData.event.admin_id
    entryCredit.total_amount = entryCredit.show_amount
    entryCredit.created_by = getters.getUserID
    entryCredit.event_id = getters.adminEventID
    entryCredit.type = 'CREDIT'
    entryCredit.status = 'PAID'
    commit('adminDataAddPayment', entryCredit)
    return rootState.apiInstance.post('/data/payments', {
      admin_id: state.adminData.event.admin_id,
      show_amount: entryCredit.show_amount * 100,
      total_amount: entryCredit.show_amount * 100,
      created_by: getters.getUserID,
      event_id: getters.adminEventID,
      entry_group_id: entryCredit.entry_group_id,
      user_id: entryCredit.user_id,
      type: 'CREDIT',
      status: 'PAID',
      date_paid: entryCredit.date_paid,
      email: entryCredit.email,
      details: entryCredit.details
    })
      .then(response => {
        if (response.status === 200) {
          commit('adminDataSetNewPaymentID', {payment_id: response.data.data.payment_id})
          if (!entryCredit.date_entered && entryCredit.entry_group_id) {
            dispatch('setEntryDate_admin', {entry_group_id: entryCredit.entry_group_id, date_entered: new Date(entryCredit.date_paid)})
          }
          if (!entryCredit.entry_group_id) {
            rootState.apiInstance.get(`/callFunction/checkCredits?event_id=${getters.adminEventID}`)
          }
        } else {
          commit('adminDataRemoveNewPayment')
          return Promise.reject(new Error('Credit not added.'))
        }
      })
      .catch(error => {
        commit('adminDataRemoveNewPayment')
        return Promise.reject(error)
      })
  },
  removeCredit: ({commit, rootState}, payment) => {
    return rootState.apiInstance.delete(`/data/payments/${payment.payment_id}`)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataRemovePayment', payment)
        } else {
          return Promise.reject(new Error('Rule not deleted'))
        }
      })
  },
  refundCharge: ({commit, rootState}, chargeDetails) => {
    return rootState.apiInstance.post(`/stripe/refundCharge?`, chargeDetails)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject(new Error('Error issuing refund'))
        }
      })
  },
  // Exhibitor Number
  checkExhibitorNumber: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/checkExhibitorNumber', {exhibitor_id: payload.exhibitor_id, event_id: payload.event_id})
  },
  // Edit Entry Admin Functions
  createEntry_admin_: ({commit, state, getters, rootState, dispatch}, payload) => {
    // Quick Fix for Adding In the Exhibitor
    payload.newEntry.exhibitor_id = payload.newEntry.exhibitor.exhibitor_id
    // TODO: FIx this monstrosity
    // let originalEntryType = payload.entry_type
    let split = payload.entry_type.split('_')[0]
    if (split === 'SHOWMANSHIP') {
      payload.entry_type = split
    }

    // payload.newEntry.entry_group_id = state.currentEntryGroup.entry_group_id
    payload.newEntry.admin_id = state.adminData.event.admin_id
    // payload.newEntry.user_id = getters.getUserID
    payload.newEntry.entry_type = payload.entry_type
    payload.newEntry.created_by = getters.getUserID

    var newEntry = JSON.parse(JSON.stringify(payload.newEntry))
    /* var showList = []
    newEntry.shows.forEach(s => {
      showList.push(s.value)
    })
    newEntry.shows = showList */

    /* var classObject = rootState.classes[originalEntryType].filter(c => c.classID === newEntry.class_id)[0]
    newEntry.class_number = classObject.classNumber */
    // commit('addEntry', {type: payload.entry_type.toLowerCase(), newEntry: newEntry})
    // commit('setLastAddedEntry_admin', newEntry)

    return rootState.apiInstance.post('/addEntries', payload.newEntry)
      .then(response => {
        // Don't need this for the admin part
        // Maybe change to updateInvoiceData
        // dispatch('getInvoiceData', {entry_group_id: payload.entry_group_id})
        var entryIDs = []
        response.data.data.forEach(d => {
          entryIDs.push(d.entry_id)
        })
        newEntry.entry_ids = entryIDs
        // commit('addEntry_admin', newEntry)
        // dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
        return Promise.resolve(response)
      })
      .catch(error => {
        // var index = state.currentEntryGroup.entries[newEntry.entryType.toLowerCase()].findIndex(e => e.name === newEntry.name)
        // commit('deleteEntry', {type: newEntry.entryType.toLowerCase(), index: index})
        return Promise.reject(error)
      })
  },
  createEntry_admin: ({commit, state, getters, rootState, dispatch}, payload) => {
    payload.newEntry.admin_id = state.adminData.event.admin_id
    payload.newEntry.created_by = getters.getUserID
    payload.newEntry.exhibitor_id = payload.newEntry.exhibitor.exhibitor_id
    payload.newEntry.animal_id = payload.newEntry.animal ? payload.newEntry.animal.animal_id : null
    payload.newEntry.is_admin = true

    var newEntry = JSON.parse(JSON.stringify(payload.newEntry))
    var showList = []
    newEntry.shows.forEach(s => {
      showList.push(s.value)
    })
    newEntry.shows = showList

    // commit('addEntry', {newEntry: newEntry})
    // commit('setLastAddedEntry', newEntry)

    return rootState.apiInstance.post('/addEntries', payload.newEntry)
      .then(response => {
        var entryIDs = []
        response.data.data.forEach(d => {
          entryIDs.push(d.entry_id)
        })
        newEntry.entry_ids = entryIDs
        // commit('addEntry_admin', newEntry)
        // dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
        dispatch('saveAnimal', {exhibitor_id: payload.newEntry.exhibitor_id, animal: payload.newEntry.animal, entry_ids: entryIDs, admin: true})
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
        return Promise.resolve(response)
      })
      .catch(error => {
        // var index = state.currentEntryGroup.entries[newEntry.entryType.toLowerCase()].findIndex(e => e.name === newEntry.name)
        // commit('deleteEntry', {index: index})
        return Promise.reject(error)
      })
  },
  editEntry_admin_: ({commit, state, getters, rootState, dispatch}, payload) => {
    // console.log(payload)
    // TODO: Add all Edit Entry Logic To the Database??
    // TODO: Implement optimistic updates in UI so I don't have to rely on full refresh
    var promises = []
    var promisesTypes = []
    // TODO: Change this to be consistent with CreateEntry
    // let originalEntryType = payload.entryType
    let split = payload.entryType.split('_')[0]
    if (split === 'SHOWMANSHIP') {
      payload.entryType = split
    }

    var index = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0].entries.findIndex(e => e.entry_ids[0] === payload.updateEntry.entry_ids[0])
    // commit('setLastEditedEntry', state.currentEntryGroup.entries[payload.entryType.toLowerCase()][index])

    if (payload.type === 'Class' || payload.type === 'Entry Details') {
      payload.updateEntry.entry_ids.forEach(e => {
        // promises.push(rootState.apiInstance.put(`/data/entries/${e}`, {
        promises.push(rootState.apiInstance.put(`/editEntries/${e}`, {
          entry_details: payload.updateEntry.entry_details,
          class_id: payload.updateEntry.class_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id
        }))
        // promises.push(Promise.reject(new Error('Fake error for test')))
      })
      var updatedEntry = JSON.parse(JSON.stringify(payload.updateEntry))
      /* var showList = []
      updatedEntry.shows.forEach(s => {
        showList.push(s.value)
      })
      updatedEntry.shows = showList */
      updatedEntry.entry_type = payload.entryType
      updatedEntry.class_id = payload.updateEntry.class_id
      updatedEntry.class_number = payload.updateEntry.class_number
      updatedEntry.class_name = payload.updateEntry.class_name
      updatedEntry.exhibitor_id = payload.updateEntry.exhibitor.exhibitor_id
      // commit('updateEntry', {index: index, type: payload.entryType.toLowerCase(), entry: updatedEntry})
    } else if (payload.type === 'Shows') {
      // var showsToAdd = []
      // Check if new Show
      /* payload.updateEntry.shows.forEach(s => {
        let osMatch = payload.updateEntry.originalShows.filter(os => { return s.vlaue === os.value })
        if (osMatch.length === 0) {
          // Then is a new show
          showsToAdd.push(s)
        }
      }) */
      let showsToAdd = [] // payload.updateEntry.shows.filter(s => { return s.show_id })
      payload.updateEntry.shows.forEach(s => {
        if (payload.updateEntry.originalShows.indexOf(s.value) === -1) {
          // Then is a new show
          showsToAdd.push(s)
        }
      })
      if (showsToAdd.length) {
        var newEntry = {
          class_id: payload.updateEntry.class_id,
          entry_details: payload.updateEntry.entry_details,
          shows: showsToAdd,
          created_by: getters.getUserID,
          user_id: payload.updateEntry.user_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id
        }
        newEntry.admin_id = state.adminData.event.admin_id
        payload.newEntry.admin_id = state.adminData.event.admin_id

        // payload.newEntry.user_id = getters.getUserID
        newEntry.entry_group_id = payload.entry_group_id // state.currentEntryGroup.entry_group_id
        newEntry.entry_type = payload.entryType
        newEntry.class_name = payload.updateEntry.class_name

        if (payload.entryType === 'BREEDING') {
          newEntry.goat_id = payload.updateEntry.entry_details.goat_id
        }

        showsToAdd.forEach(s => {
          commit('addShowToEntry_admin', {index: index, show: s, entry_group_id: payload.entry_group_id})
        })
        promises.push(rootState.apiInstance.post(`/addEntries/`, newEntry))
        promisesTypes.push('add')
      }
      // Check for deleted show
      payload.updateEntry.originalShows.forEach((s, i) => {
        if (!payload.updateEntry.shows.filter(show => { return show.value === s }).length) {
          // Then is a deleted show
          // TODO: Need to update logic to be from backend
          let showIDToRemove = s
          let entry = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0].entries[index]
          let entryIDToRemove = entry.show_entries.entry_ids[entry.show_entries.show_ids.findIndex(id => id === showIDToRemove)]

          // Requires shows and entries being sorted the same way by show_id
          promises.push(rootState.apiInstance.delete(`/data/entries/${entryIDToRemove}`))
          promisesTypes.push('delete')

          commit('removeShowFromEntry_admin', {index: index, showID: s, entry_group_id: payload.entry_group_id, shows: payload.updateEntry.shows})
        }
      })
    }
    return Promise.all(promises)
      .then(response => {
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
      })
      .catch(error => {
        // commit('updateEntry', {index: index, type: payload.entryType.toLowerCase(), entry: state.lastEditedEntry})
        return Promise.reject(error)
      })
  },
  editEntry_admin: ({commit, state, getters, rootState, dispatch}, payload) => {
    var promises = []
    var promisesTypes = []

    // var index = state.currentEntryGroup.entries.findIndex(e => e.entry_ids[0] === payload.updateEntry.entry_ids[0])
    var index = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0].entries.findIndex(e => e.entry_ids[0] === payload.updateEntry.entry_ids[0])
    // commit('setLastEditedEntry', state.currentEntryGroup.entries[index])

    if (payload.type === 'Class' || payload.type === 'Entry Details') {
      payload.updateEntry.entry_ids.forEach(e => {
        promises.push(rootState.apiInstance.put(`/editEntries/${e}`, {
          entry_details: payload.updateEntry.entry_details,
          class_id: payload.updateEntry.class_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id,
          created_at: payload.updateEntry.created_at,
          is_admin: true
        }))
      })
      var updatedEntry = JSON.parse(JSON.stringify(payload.updateEntry))
      var showList = []
      updatedEntry.shows.forEach(s => {
        showList.push(s.value)
      })
      updatedEntry.shows = showList

      // commit('updateEntry', {index: index, entry: updatedEntry})
    } else if (payload.type === 'Shows') {
      var showsToAdd = []
      // Check if new Show
      payload.updateEntry.shows.forEach(s => {
        if (payload.updateEntry.originalShows.indexOf(s.value) === -1) {
          // Then is a new show
          showsToAdd.push(s)
        }
      })

      if (showsToAdd.length) {
        var newEntry = {
          class_id: payload.updateEntry.class_id,
          entry_details: payload.updateEntry.entry_details,
          shows: showsToAdd,
          created_by: getters.getUserID,
          user_id: payload.updateEntry.user_id,
          exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id,
          animal_id: payload.updateEntry.animal ? payload.updateEntry.animal.animal_id : null,
          is_admin: true
        }
        // newEntry.user_id = state.currentEntryGroup.user_id
        newEntry.entry_group_id = payload.entry_group_id
        newEntry.admin_id = state.adminData.event.admin_id
        newEntry.entry_type = payload.updateEntry.entry_type
        newEntry.status = payload.status

        // Don't copy place
        newEntry.entry_details.place = null

        /* showsToAdd.forEach(s => {
          commit('addShowToEntry', {index: index, showID: s.value})
        }) */
        promises.push(rootState.apiInstance.post(`/addEntries/`, newEntry))
        promisesTypes.push('add')
      }

      // Check for deleted show
      payload.updateEntry.originalShows.forEach((s, i) => {
        if (!payload.updateEntry.shows.filter(show => { return show.value === s }).length) {
          promises.push(rootState.apiInstance.delete(`/data/entries/${payload.updateEntry.entry_ids[i]}`))
          promisesTypes.push('delete')
          // commit('removeShowFromEntry', {index: index, showID: s})
        }
      })
    }
    return Promise.all(promises)
      .then(response => {
        /* response.forEach((r, i) => {
          if (promisesTypes[i] === 'add') {
            r.data.data.forEach(d => {
              commit('addEntryIDToEntry', {index: index, entry_id: d.entry_id})
            })
          }
        })
        dispatch('getInvoiceData', {entry_group_id: state.currentEntryGroup.entry_group_id}) */
        if (payload.updateEntry.animal) {
          dispatch('saveAnimal', {exhibitor_id: payload.updateEntry.exhibitor.exhibitor_id, animal: payload.updateEntry.animal, entry_ids: payload.updateEntry.entry_ids, admin: true})
        }
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
      })
      .catch(error => {
        commit('updateEntry', {index: index, entry: state.lastEditedEntry})
        return Promise.reject(error)
      })
  },
  deleteEntry_admin: ({commit, state, getters, rootState, dispatch}, payload) => {
    var promises = []
    // var index = state.adminData.entry_groups.filter(eg => { return eg.entry_group_id === payload.entry_group_id })[0].entries.findIndex(e => e.entry_ids[0] === payload.entry_ids[0])
    payload.entry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.delete(`/data/entries/${e}`))
    })
    return Promise.all(promises)
      .then(response => {
        // commit('deleteEntry_admin', {entry_group_id: payload.entry_group_id, index: index})
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  deleteIndividualEntry_admin: ({commit, state, gettes, rootState, dispatch}, payload) => {
    return rootState.apiInstance.delete(`/data/entries/${payload.entry_id}`)
      .then(response => {
        // commit('deleteEntry_admin', {entry_group_id: payload.entry_group_id, index: index})
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  updateEntryGroup_admin: ({commit, state, getters, rootState, dispatch}, payload) => {
    return rootState.apiInstance.get(`/callFunction/adminGetEntryGroup?entry_group_id=${payload.entry_group_id}`)
    // return rootState.apiInstance.get(`/updateAdminEntryGroup?enry_group_id=${payload.entry_group_id}`)
      .then(response => {
        // Edited on 8/25 to fix entry grouping
        let entryGroup = Vue.prototype.fixEntryGrouping(response.data.data.entry_group)
        commit('setEntryGroup_admin', {entry_group: entryGroup})
        commit('setAnimals_admin', {animals: response.data.data.animals})
        dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
        return entryGroup
      })
  },
  getInvoiceData_admin: ({commit, state, getters, rootState, dispatch}, payload) => {
    commit('setInvoiceLoading', {entry_group_id: payload.entry_group_id})
    return rootState.apiInstance.get(`/invoice?entry_group_id=${payload.entry_group_id}`)
      .then(response => {
        commit('setInvoiceData_admin', {invoice_data: response.data.data, entry_group_id: payload.entry_group_id})
        return response.data.data
      })
  },
  checkInExhibitor: ({commit, state, rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/entryGroups/${payload.entry_group_id}`, {checkin_complete: payload.complete})
      .then(response => {
        commit('setCheckInComplete', payload)
      })
  },
  updateMemberStatus: ({commit, state, rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/entryGroups/${payload.entry_group_id}`, {member_pricing: payload.member_pricing})
      .then(response => {
        commit('setMemberStatus', payload)
        dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
      })
  },
  updateEntryExhibitor: ({commit, rootState}, payload) => {
    let promises = []
    payload.updateEntry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.put(`/data/entries/${e}`, {
        entry_details: payload.updateEntry.entry_details
      }))
    })
    return Promise.all(promises)
  },
  updateEntryWeight: ({commit, rootState}, payload) => {
    let promises = []
    payload.updateEntry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.put(`/data/entries/${e}`, {
        entry_details: payload.updateEntry.entry_details
      }))
    })
    return Promise.all(promises)
  },
  updateEntryClassification: ({commit, rootState}, payload) => {
    let promises = []
    payload.updateEntry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.put(`/data/entries/${e}`, {
        entry_details: payload.updateEntry.entry_details
      }))
    })
    return Promise.all(promises)
  },
  setCheckInEntry: ({commit, rootState}, payload) => {
    let promises = []
    payload.updateEntry.entry_ids.forEach(e => {
      promises.push(rootState.apiInstance.put(`/data/entries/${e}?update_timestamp=false`, {
        checked_in: payload.updateEntry.checked_in
      }))
    })
    return Promise.all(promises)
  },
  generateMarketClassList: ({rootState}, payload) => {
    return rootState.apiInstance.get(`/createMarketClassListNew?event_id=${payload.event_id}&show_id=${payload.show_id}`)
  },
  generateShowBook: ({rootState}, payload) => {
    return rootState.apiInstance.get(`/generateShowBook?show_id=${payload.show_id}&preview=${payload.preview}`)
  },
  saveShowBook: ({rootState}, payload) => {
    // // console.log('Makre sure you replace this code\nDont forget about the bred and owned debacle')
    return rootState.apiInstance.post('/callFunction/saveShowBook', {showBookData: JSON.stringify(payload)})
  },
  saveShowBookManual: ({rootState}, payload) => {
    /* event_id: this.adminData.event.event_id,
    show_id: this.show_book.show_id,
    show_book: this.breakEntries,
    user_id: this.currentUser.user_id */
    return rootState.apiInstance.post('/saveShowBookManual', payload)
  },
  getShowBook: ({rootState}, payload) => {
    if (payload.ring_id) {
      return rootState.apiInstance.get(`/getShowBook?show_id=${payload.show_id}&ring_id=${payload.ring_id}&preview=${payload.preview}&regen=${payload.regen}&breakable=${payload.breakable}&results=${payload.results}&start_date=${payload.start_date}&use_dynamic=${payload.use_dynamic}&no_ring_filter=${payload.no_ring_filter}&add_class_numbers=${payload.add_class_numbers}&testMode=${payload.testMode}&structure_only=${payload.structure_only}`)
    } else {
      return rootState.apiInstance.get(`/getShowBook?show_id=${payload.show_id}&preview=${payload.preview}&regen=${payload.regen}&breakable=${payload.breakable}&results=${payload.results}&start_date=${payload.start_date}&use_dynamic=${payload.use_dynamic}&no_ring_filter=${payload.no_ring_filter}&add_class_numbers=${payload.add_class_numbers}&testMode=${payload.testMode}&structure_only=${payload.structure_only}`)
    }
  },
  saveEntryPlacing: ({rootState}, payload) => {
    return rootState.apiInstance.put(`/data/entries/${payload.entry_id}`, {entry_details: payload.entry_details})
  },
  saveEntryScore: ({rootState}, payload) => {
    return rootState.apiInstance.put(`/data/entries/${payload.entry_id}`, {entry_details: payload.entry_details})
  },
  saveEntryRibbon: ({rootState}, payload) => {
    return rootState.apiInstance.put(`/data/entries/${payload.entry_id}`, {entry_details: payload.entry_details})
  },
  saveShowChampionResults: ({rootState}, payload) => {
    return rootState.apiInstance.put(`/data/shows/${payload.show_id}`, {champion_results: payload.champion_results})
  },
  saveEntryQuestions_admin: ({rootState, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/entryGroups/${payload.entry_group_id}`, {entry_questions: payload.entry_questions})
      .then(response => {
        dispatch('updateEntryGroup_admin', {entry_group_id: payload.entry_group_id})
        // dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  saveSponsor: ({rootState, state, commit, getters}, sponsor) => {
    sponsor.admin_id = state.adminData.event.admin_id
    if (sponsor.sponsor_id) {
      sponsor.last_updated_by = getters.getUserID
      return rootState.apiInstance.put(`/data/sponsors/${sponsor.sponsor_id}`, sponsor)
    } else {
      sponsor.created_by = getters.getUserID
      return rootState.apiInstance.post('/data/sponsors', sponsor)
        .then(result => {
          sponsor.sponsor_id = result.data.data.sponsor_id
          commit('addSponsor', sponsor)
        })
    }
  },
  deleteSponsor: ({rootState, commit}, payload) => {
    return rootState.apiInstance.delete(`/data/sponsors/${payload.sponsor_id}`)
      .then(result => {
        commit('removeSponsor', payload)
      })
  },
  setEntryDate_admin: ({rootState, commit, dispatch}, payload) => {
    return rootState.apiInstance.put(`/data/entryGroups/${payload.entry_group_id}`, {date_entered: payload.date_entered})
      .then(response => {
        commit('setDateEntered', payload)
        dispatch('getInvoiceData_admin', {entry_group_id: payload.entry_group_id})
      })
  },
  // Walk-in & Mail-In
  checkEmail: ({rootState}, payload) => {
    return rootState.apiInstance.get(`/callFunction/checkEmail?exhibitorEmail=${payload.email}`)
  },
  createWalkInExhibitor: ({rootState, dispatch}, payload) => {
    return rootState.apiInstance.post(`/callFunction/newWalkInExhibitor`, {exhibitorData: JSON.stringify(payload)})
      .then(response => {
        return dispatch('loadAdminEventData', {event_slug: payload.event_slug})
          .then(() => {
            return Promise.resolve(response)
          })
      })
  },
  deleteEntryGroup: ({rootState, dispatch}, payload) => {
    return rootState.apiInstance.post('/callFunction/deleteEntryGroup', {entry_group_id: payload.entry_group_id})
      .then(response => {
        dispatch('loadAdminEventData', {event_slug: payload.event_slug})
        return Promise.resolve(response)
      })
  },

  // New Entry Questions
  createNewEntryQuestion: ({commit, state, getters, rootState}, entryQuestion) => {
    entryQuestion.admin_id = state.adminData.event.admin_id
    entryQuestion.created_by = getters.getUserID
    entryQuestion.event_id = getters.adminEventID

    // TODO: Implement Eager Saving
    return rootState.apiInstance.post('/data/entryQuestions', entryQuestion)
      .then(response => {
        if (response.status === 200) {
          entryQuestion.entry_question_id = response.data.data.entry_question_id
          commit('adminDataAddEntryQuestion', entryQuestion)
        } else {
          return Promise.reject(new Error('Entry Question not added.'))
        }
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  updateEntryQuestion: ({commit, rootState}, entryQuestion) => {
    return rootState.apiInstance.put(`/data/entryQuestions/${entryQuestion.entry_question_id}`, entryQuestion)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataUpdateEntryQuestion', entryQuestion)
        } else {
          return Promise.reject(new Error('Entry Question not updated.'))
        }
      })
  },
  removeEntryQuestion: ({commit, rootState}, entryQuestion) => {
    return rootState.apiInstance.delete(`/data/entryQuestions/${entryQuestion.entry_question_id}`)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataRemoveEntryQuestion', entryQuestion)
        } else {
          return Promise.reject(new Error('Question not deleted'))
        }
      })
  },

  previewClassList: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/previewClassList', payload)
      .then(response => {
        if (response.status < 400) {
          return response.data.data
        } else {
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(error => {
        // console.log(error)
        return Promise.reject(error)
      })
  },
  previewEntryType: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/previewEntryType', payload)
      .then(response => {
        if (response.status < 400) {
          return response.data.data
        } else {
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(error => {
        // console.log(error)
        return Promise.reject(error)
      })
  },
  addShow: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/addShow', payload)
      .then(response => {
        if (response.status < 400) {
          return response.data.data
        } else {
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(error => {
        // console.log(error)
        return Promise.reject(error)
      })
  },
  addShowDynamic: ({commit, rootState}, payload) => {
    return rootState.apiInstance.post('/addShowDynamic', payload)
      .then(response => {
        if (response.status < 400) {
          if (!payload.classConfig.class_configuration_id) {
            commit('addClassConfig', response.data.data.class_list)
          }
          if (!payload.entryType.event_show_type_id) {
            commit('addEventShowType', response.data.data.entry_type)
          }
          let show = response.data.data.show
          show.show_id = response.data.data.show_id
          if (!show.pricing_details) {
            show.pricing_details = {}
          }
          commit('adminDataAddShow', show)

          return response.data.data
        } else {
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(error => {
        // console.log(error)
        return Promise.reject(error)
      })
  },
  addShowDynamicTemplate ({commit, rootState}, payload) {
    return rootState.apiInstance.post('addShowDynamicTemplate', payload)
      .then(response => {
        if (response.status < 400) {
          if (!payload.classConfig.class_configuration_id) {
            commit('addClassConfig', response.data.data.class_list)
          }
          if (!payload.entryType.event_show_type_id) {
            commit('addEventShowType', response.data.data.entry_type)
          }
          let shows = response.data.data.shows
          shows.forEach(show => {
            if (!show.pricing_details) {
              show.pricing_details = {}
            }
            commit('adminDataAddShow', show)
          })
          return response.data.data
        } else {
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(error => {
        // console.log(error)
        return Promise.reject(error)
      })
  },
  // New Generic Actions
  addData: ({commit, rootState}, payload) => {
    payload.idName = payload.name.slice(0, -1) + '_id'

    payload.event_id = state.adminData.event.event_id
    payload.admin_id = state.adminData.event.admin_id
    payload.created_by = rootState.user.user_id

    commit('adminDataAddData', payload)
    return rootState.apiInstance.post(`/data/${payload.name}/`, payload)
      .then(response => {
        if (response.status < 400) {
          payload.id = response.data.data[payload.idName]
          commit('adminDataSetNewDataID', payload)
          return response
        } else {
          commit('adminDataRemoveNewData', payload)
          return Promise.reject(new Error('Data not added'))
        }
      })
      .catch(() => {
        // console.log(error)
        commit('adminDataRemoveNewData', payload)
      })
  },
  updateData: ({commit, rootState}, payload) => {
    payload.idName = payload.name.slice(0, -1) + '_id'
    return rootState.apiInstance.put(`/data/${payload.name}/${payload[payload.idName]}`, payload)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataUpdateData', payload)
        } else {
          return Promise.reject(new Error('Update Failed'))
        }
      })
  },
  deleteData: ({commit, rootState}, payload) => {
    payload.idName = payload.name.slice(0, -1) + '_id'

    return rootState.apiInstance.delete(`/data/${payload.name}/${[payload[payload.idName]]}`)
      .then(response => {
        if (response.status === 200) {
          commit('adminDataRemoveData', payload)
        } else {
          return Promise.reject(new Error('Data not deleted'))
        }
      })
  },
  updateShowSettings: ({commit, rootState}, payload) => {
    // if (rootState.authorizationSet) {
    return rootState.apiInstance.post(`/callFunction/updateShowSettings`, {updateData: JSON.stringify(payload)})
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response)
        } else {
          return Promise.reject(new Error('Show not updated'))
        }
      })
  },
  addExhibitorToAdminData: ({commit}, exhibitor) => {
    commit('addToExhibitorList_admin', exhibitor)
  },
  // File Functions
  updateFiles: ({commit, rootState}, payload) => {
    return rootState.apiInstance.put(`/data/events/${payload.event_id}`, {files: payload.files})
      .then(response => {
        if (response.status === 200) {
          commit('adminDataUpdateFiles', payload.files)
        } else {
          return Promise.reject(new Error('Update Failed'))
        }
      })
  },
  updateExhibitorNumber: ({commit, rootState}, object) => {
    // update AdminData
    commit('setExhibitorNumber', object)
    return rootState.apiInstance.post(`/updateExhibitorNumber`, object)
      .catch(error => {
        // re_update adminData
        object.exhibitor_number = object.originalNumber
        commit('setExhibitorNumber', object)
        return Promise.reject(error)
      })
  },
  checkEventEntryQuestionAvailability_admin ({commit, state, rootState}, payload) {
    return rootState.apiInstance.get(`/checkEntryQuestionAvailability?event_id=${state.adminData.event.event_id}&entry_question_id=${payload.entry_question_id}`)
      .then(response => {
        commit('setEntryQuestionReservations_admin', {reserved: response.data.reserved, entry_question_id: payload.entry_question_id})
        return response.data.reserved
      })
  },
  getEntryQuestions_admin: ({commit, state, rootState}, payload) => {
    return rootState.apiInstance.get(`/getUpdatedEntryQuestions?event_id=${state.adminData.event.event_id}`)
      .then(response => {
        commit('setEventEntryQuestions_admin', response.data)
        return response.data
      })
  },
  setEventSettings_admin: ({commit, state, rootState}, payload) => {
    return rootState.apiInstance.post(`/callFunction/updateEventSettings`, {
      updateData: JSON.stringify(payload)
    })
      .then(response => {
        if (response.status === 200) {
          commit('updateEventSettings_admin', payload)
          return Promise.resolve(response)
        } else {
          return Promise.reject(new Error('Settings not updated'))
        }
      })
  },
  setShowAccessList: ({commit, state, rootState}, payload) => {
    commit('updateShowAccessList', payload)
  } 
}

const getters = {
  adminEventID: state => {
    if (state.adminData.event) {
      return state.adminData.event.event_id
    } else {
      return null
    }
  },
  getEventUserRoles: state => {
    if (state.adminData) {
      return state.adminData.event_user_roles
    } else {
      return []
    }
  },
  getAccessFilteredShowList: (state, getters) => {
    let userID = getters.getUserID
    let showList = []
    if (userID === state.adminData.admin_id || UserAccess.checkUserAccess(userID, 'SUPPORT') || !state.adminData.event.event_settings.superintendent_access) {
      return state.adminData.event.shows
    } else {
      state.adminData.event.shows.forEach(s => {
        if (state.showAccessList.includes(s.show_id)) {
          showList.push(s)
        }
      })
      return showList
    }
  },
  getAccessFilteredShowBooks: (state, getters) => {
    let userID = getters.getUserID
    let showBooks = []
    if (userID === state.adminData.admin_id || UserAccess.checkUserAccess(userID, 'SUPPORT') || !state.adminData.event.event_settings.superintendent_access) {
      return state.adminData.show_books
    } else {
      state.adminData.show_books.forEach(s => {
        if (state.showAccessList.includes(s.show_id)) {
          showBooks.push(s)
        }
      })
      return showBooks
    }
  }
}
export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters
}
